import {
  BillingAnalytics,
  BillingDetail,
  BillingFrequencyEnum,
  BillingMatrix,
  Invoice,
  InvoiceUsage,
  OrganizationBillingDetails,
} from 'types/billings';

import api from './api';

export const BILLING_STATE_KEY = 'billing';

export const getBillingCheckoutHostedPage = async (orgId: string, billingPlan: 'FREE' | 'GROWTH' | 'PREMIUM') => {
  const { data } = await api.post(
    '/v1/billing/checkout_new_url',
    {
      billing_plan: billingPlan,
    },
    {
      headers: {
        'x-organization-id': orgId,
      },
    }
  );
  return data;
};

export const generateChargebeePortalSession = async (orgId: string) => {
  const { data } = await api.post(
    '/v1/billing/generate_portal_session',
    {},
    {
      headers: {
        'x-organization-id': orgId,
      },
    }
  );
  return data;
};

export const getOrgBillingInfo = async (orgId: string): Promise<BillingDetail> => {
  const { data } = await api.get(`/v1/billing`, {
    headers: {
      'x-organization-id': orgId,
    },
  });
  return data;
};

export const updateBillingPlan = async (orgId: string, billingPlan: 'PREMIUM') => {
  const { data } = await api.post(
    '/v1/billing/update_billing_plan',
    {
      billing_plan: billingPlan,
    },
    {
      headers: {
        'x-organization-id': orgId,
      },
    }
  );
  return data;
};

export const getOrgBillingHistoryChartData = async (
  orgId: string,
  frequency: BillingFrequencyEnum
): Promise<BillingAnalytics> => {
  const { data } = await api.get<BillingAnalytics>(`/v1/billing/analytics`, {
    params: {
      frequency,
    },
    headers: {
      'x-organization-id': orgId,
    },
  });
  return data;
};

export const getOrgInvoicesFromChargebee = async (orgId: string): Promise<Invoice[]> => {
  const { data } = await api.get(`/v1/billing/invoices`, {
    headers: {
      'x-organization-id': orgId,
    },
  });
  return data;
};

export const getOrgInvoiceUsage = async (orgId: string, invoiceId: string) => {
  const { data } = await api.get<InvoiceUsage[]>(`/v1/billing/invoices/${invoiceId}/usage`, {
    headers: {
      'x-organization-id': orgId,
    },
  });
  return data;
};

export const getOrgInvoicePdfFromChargebee = async (orgId: string, invoiceId: string) => {
  return api.get(`/v1/billing/invoices/${invoiceId}/pdf`, {
    headers: {
      'x-organization-id': orgId,
    },
    responseType: 'arraybuffer',
  });
};

export const getOrgBillingDetails = async (orgId: string): Promise<OrganizationBillingDetails> => {
  const { data } = await api.get(`/v1/billing_details`, {
    headers: {
      'x-organization-id': orgId,
    },
  });
  return data;
};

export const getOrgBillingMatrix = async (orgId: string): Promise<BillingMatrix> => {
  const { data } = await api.get(`/v1/billing/matrices`, {
    headers: {
      'x-organization-id': orgId,
    },
  });
  return data;
};
